import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '@app/@core/services/auth.service';
import { HttpService } from '@app/@core/services/http.service';
import { PermissionStore } from '@app/@core/store/permission.store';
import { environment } from '@env/environment';
import { BehaviorSubject, Subscription } from 'rxjs';
import { LocalService } from '@core/services/local.service';
@Component({
  standalone: false,
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss']
})
export class AnalyticsComponent implements OnInit, OnDestroy {
  RBACORG: any;
  PERMISSION: any;
  orgSubs: Subscription;
  analyticsEvent: BehaviorSubject<any>;
  constructor(private permissionStore: PermissionStore, private authService: AuthService, private httpService: HttpService, private sessionStorage: LocalService) {
    this.analyticsEvent = new BehaviorSubject<any>(null);
    this.orgSubs = this.authService.orgInfo.subscribe(o => {
      console.log('PermissionsComponent');
      this.PERMISSION = this.permissionStore.state;
      this.RBACORG = {
        tokenKey: 'jwt-token',
        apiHost: environment.apiHost,
        others: this.sessionStorage.asStorage(),
        orgID: o ? o : this.sessionStorage.getItem('orgid'),
        environment: {
          mstrUsername: environment.mstrUsername,
          mstrPassword: environment.mstrPassword,
          mstrURL: environment.mstrURL,
          mstrProjectID: environment.mstrProjectID,
          applicationid: environment.applicationid,
          priority: environment.priority,
          videoConferenceDomain: environment.videoConferenceDomain,
          ChatBotNew: environment.ChatBotNew,
          ChatBot: environment.ChatBot,
          n8nWorflowUrl: environment.n8nWorflowUrl,
          production: environment.production,
        }
      };
      this.analyticsEvent.next({
        RBACORG: this.RBACORG,
        PERMISSION: this.PERMISSION,
        httpService: this.httpService
      });
    });
  }
  ngOnInit(): void {
    console.log();
  }
  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  ngOnDestroy(): void {
    this.orgSubs.unsubscribe();
  }
}
